export interface GridColumnModel {
  id: string
  value: string
  selected: boolean
  width: string
}

export const invoiceCheckbox = 'checkbox'
export const invoiceProjectNumber = 'e2eProjectNumber'
export const invoiceOrderlineNumber = 'e2eOrderlineNumber'
export const invoiceAmount = 'invoicePriceAmount'
export const invoiceCurrency = 'invoiceCurrencyCode'

export const orderlineInvoiceColumns: GridColumnModel[] = [
  {
    id: invoiceProjectNumber,
    value: 'Project Number',
    selected: false,
    width: '70px',
  },
  {
    id: invoiceOrderlineNumber,
    value: 'Order Line Number',
    selected: false,
    width: '20px',
  },
  {
    id: invoiceAmount,
    value: 'Invoice Amount',
    selected: false,
    width: '70px',
  },
  {
    id: invoiceCurrency,
    value: 'Currency',
    selected: false,
    width: '70px',
  },
]
